import { useMemo } from 'react'
import { useHolidayQuery } from 'lib/graphql/storefront'

export interface HolidayDateType {
  id: string
  date: string
  isAutoGenerated: boolean
  isClose: boolean
  isPublic: boolean
  reason: string
}

const useCalendarHolidays = () => {
  const currentYear = new Date().getFullYear()

  const { data: holidaysData, refetch: holidaysRefetch } = useHolidayQuery({
    variables: { year: currentYear },
  })

  const holidaysDataSource = useMemo(() => {
    return holidaysData?.holiday?.holidays?.edges?.map(({ node }) => {
      return {
        id: node?.id,
        date: node?.date,
        isAutoGenerated: node?.isAutoGenerated,
        isClose: node?.isClose,
        isPublic: node?.isPublic,
        reason: node?.reason?.jaJp,
      }
    })
  }, [holidaysData])

  // 全ての祝日(isPublic)
  const publicHolidays = useMemo(() => {
    return (
      holidaysDataSource
        ?.filter((item) => item?.isPublic)
        ?.map((item) => new Date(item?.date)) || []
    )
  }, [holidaysDataSource])

  // 休業日など(isClose)
  const excludeDates = useMemo(() => {
    return (
      holidaysDataSource
        ?.filter((item) => item?.isClose)
        ?.map((item) => new Date(item?.date)) || []
    )
  }, [holidaysDataSource])

  return {
    holidaysData,
    holidaysRefetch,
    holidaysDataSource,
    publicHolidays,
    excludeDates,
  }
}

export default useCalendarHolidays
